export default "__VITE_ASSET__a19af724__"